module.exports = __webpack_public_path__ + "static/img/zz_zhibo.e8fadff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zz_zhibo.png
// module id = 5swc
// module chunks = 1